export default function createStartThirdPartyDialogLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `start-dialog:${input.type}` });
    return {
        opened() {
            return log({
                type: "opened",
            });
        },
        closed(option) {
            return log({
                type: "closed",
                details: { option },
            });
        },
    };
}
